module.exports = __webpack_public_path__ + "static/img/return_bad_example_1.7328d8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/return_bad_example_1.jpg
// module id = Pqre
// module chunks = 1